module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "container-floating"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-676d6205"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/MainBottomRightButtons.vue
// module id = 706
// module chunks = 1